import {
    STARRED_REPORT_TABS,
    StarredReportTabsTypes,
} from 'features/star-report/components/starred-reports-tabs';
import { chainsBasename } from 'features/chains/router/chains-router';
import { useSelector } from 'react-redux';
import { selectChainsDefaultReportURL } from 'features/chains/store/chains-report-chains-store';
import {
    selectMarketDefaultReportURL,
    selectPropertyDefaultReportURL,
} from 'store/header/navigation';
import { useMemo } from 'react';
import { useRelativeUrl } from 'hooks/use-relative-url';

export const useAllStarredReportsUrl = (selectedTab: StarredReportTabsTypes) => {
    const urlPath = useRelativeUrl();
    const defaultChainsReportURL = useSelector((state: any) =>
        selectChainsDefaultReportURL(state, urlPath),
    );
    const defaultPropertyReportURL = useSelector(selectPropertyDefaultReportURL);
    const defaultMarketReportURL = useSelector(selectMarketDefaultReportURL);

    return useMemo(() => {
        const url =
            selectedTab === STARRED_REPORT_TABS.PROPERTY
                ? defaultPropertyReportURL
                : selectedTab === STARRED_REPORT_TABS.MARKET
                ? defaultMarketReportURL
                : `${chainsBasename}${defaultChainsReportURL}`;
        return url.replace('/overview', '/starred-reports');
    }, [defaultChainsReportURL, defaultMarketReportURL, defaultPropertyReportURL, selectedTab]);
};
